import React from 'react'
import styles from './IconsBlocks.module.scss'
import { Color } from '../../lib/types'
import { SVGIcon } from '../SVGIcon/SVGIcon'

interface IProps {
  data: {
    icon: string
    iconColor: Color
    borderColor: Color
    text: string
    style?: React.CSSProperties
    className?: string
  }[]
}

export const IconsBlocks = (props: IProps): React.JSX.Element => {
  return (
    <div className={`icon-blocks__container ${styles.container}`}>
      {props.data.map((item) => (
        <div
          key={item.icon}
          style={item.style}
          className={`border-color--${item.borderColor} ${item.className}`}
        >
          <div className={styles.iconWrap} style={item.style}>
            <SVGIcon id={item.icon} color={item.iconColor} />
          </div>
          <p>{item.text}</p>
        </div>
      ))}
    </div>
  )
}
